

const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
const SET_AUTHENTICATED = "SET_AUTHENTICATED";
const SET_USER = "SET_USER";
const SET_DEVICE = "SET_DEVICE";

export {
   SET_AUTHENTICATED,
   SET_CURRENT_ROUTE,
   SET_DEVICE,
   SET_USER
};